import api, { request } from '../../../../api';
import { groupBy } from '../../../../contrib/utils';
import { IStore } from '../../../index';
import { IAward } from '../../eventAwards/store';

export const create = async (
  state: IStore,
  roundId: number | string,
  formatId: number,
  instances: IAward[]
) => {
  const response = await request.patch(api.admin.roundFormatAwards(formatId), { instances });

  if (response.error) {
    return {
      errors: {
        adminRoundFormatAwards: { msg: 'Error retrieving the Round Format Awards List.' }
      }
    };
  }

  return {
    adminRoundFormatAwards: {
      ...state.adminRoundFormatAwards,
      [roundId]: {
        ...state.adminRoundFormatAwards[Number(roundId)],
        [formatId]: groupBy(response, 'user')
      }
    }
  };
};
